<style scoped lang="scss">
.circular-send-progress {
  display: flex;
  align-items: center;
  background-color: $teal;
}
.progress-box {
  display: flex;
  align-items: center;
  width: 150px;
  margin-top: 5px;
  border: solid 1px $gray-500;
  background-color: $gray-500;
  border-radius: 50px;
}
</style>
<template>
  <td>
    {{
      this.formatedNumber(
        model[firstAttribute] >= alreadySend
          ? model[firstAttribute]
          : alreadySend
      )
    }}
    / {{ this.formatedNumber(model[secondAttribute]) }} |
    {{
      Math.round(
        ((model[firstAttribute] >= alreadySend
          ? model[firstAttribute]
          : alreadySend) /
          model[secondAttribute]) *
          100,
        2
      )
    }}%
    <div class="progress-box">
      <div
        class="progress-bar progress circular-send-progress"
        role="progressbar"
        :aria-valuenow="
          Math.round(
            ((model[firstAttribute] >= alreadySend
              ? model[firstAttribute]
              : alreadySend) /
              model[secondAttribute]) *
              100,
            2
          )
        "
        aria-valuemin="0"
        aria-valuemax="100"
        :style="
          'width: ' +
            Math.round(
              ((model[firstAttribute] >= alreadySend
                ? model[firstAttribute]
                : alreadySend) /
                model[secondAttribute]) *
                100,
              2
            ) +
            '%'
        "
      ></div>
    </div>
  </td>
</template>

<script lang="babel">
import { bus } from "@/bus";

export default {
  name: "circular-mail-status-cell",
  props: ["model", "attribute"],
  computed: {
    mailId() {
      return this.model.id;
    },
    firstAttribute() {
      return this.attribute.firstAttribute;
    },
    secondAttribute() {
      return this.attribute.secondAttribute;
    },
  },
  data() {
    return {
      alreadySend: 0,
      id: null
    };
  },
  created(){
    bus.$on("circular-mail-status", data => {
      if (this.mailId== data.id) {
        this.alreadySend = data.alreadySend;
      }
    });
  },
  methods: {
    formatedNumber(numberToFormat){
      return new Intl.NumberFormat('de-DE').format(numberToFormat);
    }
  }
};
</script>
